import { useLocation } from '@tanstack/react-router'
import { OrderDetailsModal } from './OrderDetailsModal'

/**
 * Component that provides the OrderDetailsModal based on URL search params
 * This allows the parent route to remain visible while showing the order details
 */
export function OrderDetailsModalProvider() {
  const { pathname, search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const orderId = searchParams.get('orderId') || undefined
  const noBackdrop = Boolean(searchParams.get('noBackdrop'))

  if (!orderId) {
    return null
  }

  return (
    <OrderDetailsModal
      orderId={orderId}
      parentPath={pathname}
      withoutBackdrop={noBackdrop}
    />
  )
}
